import * as React from 'react'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral';

// import ImagePhotoAuthInfo from '../../UploadImage/ImagePhotoAuthInfo';
import FilesUploadNameChange from './FilesUploadNameChange';
import FilesUploadActionSocket from './FilesUploadActionSocket';
import Loader from '../Loader/Loader';

import { useStore } from '../../hook-store/store';
import { s3fileUpload2 } from '../../utils/file-upload-util/bucket-upload-util';
import { uploadLargeFileForProcess } from '../../utils/large-file-upload-utils/large-file-upload-utils';
import { mimeTypes } from '../../utils/file/mime-type';
import { BACKEND_URL } from '../../App';

import { marks } from '../../utils/marks';
import './FilesUploadAction.css';
// import classes from './BgRemoveUpload.module.css';

const FilesUploadAction = (props) => {
  const { 
    uploadFiles,
    uploadApp,
  } = props

  const [t] = useTranslation('translation')

  const [store, dispatch] = useStore();
  const { 
    bucketName, 
    topLevels, 
    totalSizeGB, 
    limitGB,
    // selectedPrefix,
  } = store.bucketObjectStore;
  const { gLoading, isAuth } = store.uiStore;
  const { 
    serviceBucketsDataList,
    serviceTotalSizeGB,
  } = store.serviceBucketsStore;
  // const { mlSpeechInputFileName} = store.mlSpeechStore;

  const [kuraStorageBucketData, setKuraStorageBucketData] = useState();
  const [resultMessage, setResultMessage] = useState('');
  const [uploadNameFile, setUploadNameFile] = useState();
  const [canUpload, setCanUpload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // let canUpload = false;

  // if (isAuth && kuraStorageBucketData && uploadFiles) {
  //   canUpload = true;
  // }

  useEffect(() => {
      if (limitGB && serviceTotalSizeGB && limitGB > serviceTotalSizeGB &&
          (serviceBucketsDataList && serviceBucketsDataList.length > 0)
      ) {
        setCanUpload(true);
      }

      //// update service bucket info when not exist
      if (serviceBucketsDataList && serviceBucketsDataList.length === 0) {
        //// set isUploadFailed for get services bucket info (sizes)
        dispatch('SET_ISUPLOADFAILED', true);
      }
  },[serviceBucketsDataList, limitGB, serviceTotalSizeGB]);


  // console.log(uploadFiles)

  // console.log('bucketName', bucketName, canUpload, isAuth, kuraStorageBucketData, uploadFiles);

  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);

  useEffect(() => {

    const kuraStorageBucketData = serviceBucketsDataList.find(element => {
      return element.bucket === localStorage.getItem('userId');
    });
  
    let bucketName = '';
    
    if (kuraStorageBucketData) {
      //@ts-ignore
      dispatch('SET_BUCKETNAME', kuraStorageBucketData.bucket);
      setKuraStorageBucketData(kuraStorageBucketData);
    }

  },[serviceBucketsDataList]);


  useEffect(() => {
    if (uploadFiles?.length > 0 && !uploadNameFile) {
      createUploadNameFile(uploadFiles[0], uploadApp);
    }
  },[uploadFiles]);


  const createFileName = (file, uploadApp) => {
    let name;

    if (uploadApp === 'audioTranscriber') {
      if (file.type?.split('/')[0] === 'text') {
        
        name = file.name;
        // const nameSplits = file.name?.split('.');

        // if (nameSplits) {
        //   const ext = nameSplits.pop();

        //   // name = `audio-transcript-${Date.now()}.txt`;
        //   name = `audio-transcript-${Date.now()}.${ext}`
        // }
      }

      if (file.type?.split('/')[0] === 'audio') {
        // let ext = 'mp3';

        // if (mlSpeechInputFileName) {
        //   const fileSplit = mlSpeechInputFileName.split('.');
        //   const fileExt = fileSplit.pop();
        //   ext = fileExt;
        // }

        // for (const mExt in mimeTypes) {
        //   const matchMime = mimeTypes[mExt] === file.type;

        //   if (matchMime) {
        //     ext = mExt;
        //   };

        //   console.log(matchMime)
        // }

        // name = `audio-transcriber-input-${Date.now()}.${ext}`;
        name = file.name;
      }

      if (file.type?.split('/')[0] === 'video') {
        // let ext = 'mp4';

        // if (mlSpeechInputFileName) {
        //   const fileSplit = mlSpeechInputFileName.split('.');
        //   const fileExt = fileSplit.pop();
        //   ext = fileExt;
        // }
        
        // for (const mExt in mimeTypes) {
        //   const matchMime = mimeTypes[mExt] === file.type;

        //   if (matchMime) {
        //     ext = mExt;
        //   };

        //   console.log(matchMime)
        // }
        // name = `audio-transcriber-input-${Date.now()}.${ext}`;
        name = file.name;
      }
    }

    if (uploadApp === 'voiceGenerator') {
      if (file.type === 'text/plain') {
        name = `voice-input-text-${Date.now()}.txt`;
      }

      if (file.type === 'audio/wav') {
        name = `output-voice-${Date.now()}.wav`;
      }

    }

    if (uploadApp === 'answerFinder') { 
      name = `answer-finder-${Date.now()}.txt`;
    }

    if (uploadApp === 'videoToAudio') {
      name = `converted-audio-${Date.now()}.${file.type.split('/')[1]}`
    }

    if (uploadApp === 'videoToMp4') {
      name = `converted-${Date.now()}.${file.type.split('/')[1]}`
    }

    if (uploadApp === 'audioSlicer') {
      name = `slice-audio-${Date.now()}.${file.type.split('/')[1]}`
    }

    if (uploadApp === 'audioCombiner') {
      name = `combine-audio-${Date.now()}.${file.type.split('/')[1]}`
    }

    if (uploadApp === 'audioAmpChanger') {
      name = `amp-changed-audio-${Date.now()}.${file.type.split('/')[1]}`
    }

    if (uploadApp === 'audioConvertToMP3') {
      name = `converted-audio-${Date.now()}.${file.type.split('/')[1]}`
    }

    if (uploadApp === 'audioMixer') {
      name = `mixed-audio-${Date.now()}.${file.type.split('/')[1]}`
    }

    if (uploadApp === 'pdfToText') {
      if (file.type === 'application/pdf') {
        name = `input-pdf-${Date.now()}.pdf`
      } else {
        name = file.name;
      }
    }

    if (uploadApp === 'textVoiceAssistant') {
      name = `text-voice-assistant-${Date.now()}.txt`
    }

    return name;
  };

  const createUploadNameFile = (file, uploadApp) => {
    const name = createFileName(file, uploadApp);

    if (!name) {
      return;
    }

    console.log(name);
    // throw new Error('error-error');

    const uploadFile = new File([file], name, {type: file.type});
    setUploadNameFile(uploadFile);
    console.log(uploadFile);
    return uploadFile;
  };

  const filesUploadHandler = async (path, files, uploadApp) => {
    try {
      // setIsLoading(true);
      setResultMessage('');

      //@ts-ignore
      dispatch('SET_GLOADING', true);

      let resultsForAction = {
        fileUpload: null,
      };


      // if (!file) {
      //   throw new Error('error occured');
      // }

      const file = files[0]

      console.log(file, uploadApp, file.type);
      // throw new Error('error-error')

      // const name = createFileName(file, uploadApp);

      // if (!name) {
      //   throw new Error('name is required');
      // }

      // console.log(name);
      // // throw new Error('error-error');

      // const uploadFile = new File([file], name, {type: file.type});

      // const uploadFile = await uploadFileCreate(curRender.currentSrc, name, file.type);
      
      // const files = [uploadFile];
      // console.log('file, files', file, files);
      // console.log(currentRenderFile);
      console.log(path, files);
      // throw new Error('error-error');

      if (!files || files.length === 0) {
        throw new Error('upload file is required');
      }

      if (files.length > 10) {
        throw new Error('Upload limit is 10 file');
      }

      let uploadSizeGB = 0;
      // let limitGB = 0.1;

      for (const file of files) {
        uploadSizeGB = uploadSizeGB + file.size / 10**9;
      }

      // console.log('uploadSizeGB', uploadSizeGB, totalSizeGB);

      // const activeSubscription = subscriptions.find(subscription => {
      //   return subscription.status === 'active';
      // });

      // if (activeSubscription) {
      //   limitGB = parseInt(activeSubscription.metadata.storeSizeGB);
      // }
      
      if ((totalSizeGB + uploadSizeGB) > limitGB) {
        throw new Error('Total file sizes are more than limit');
      }


      // console.log(hasActiveSubscription, hasActiveSubscription2);


      let result;

      // result = await s3fileUpload2(
      //   BACKEND_URL,
      //   localStorage.getItem('token'),
      //   path,
      //   [file],
      //   bucketName,
      //   dispatch,
      //   uploadApp,
      // );

      result = await s3fileUploadLf(
        BACKEND_URL,
        localStorage.getItem('token'),
        path,
        file,
        bucketName,
        1,
        0,
        uploadApp,
      );

      console.log(result);

      if (!result) {
        throw new Error('error occured');
      }
      
      resultsForAction.fileUpload = result.data;

      // setSelectedFiles(null);

      // const addedList = topLevels.concat(result.data.data);
      
      //@ts-ignore
      // dispatch('SET_TOPLEVELS', addedList);


      // //@ts-ignore
      // dispatch('SET_OBJECTACTION', {
      //   actionType: 'file-upload',
      //   delete: false,
      //   add: true,
      //   result: resultsForAction,
      // });

      // //@ts-ignore
      // dispatch('SET_DATAFORMETADATA', result.data.dataForMetadata);

      //@ts-ignore
      dispatch('SHOW_NOTIFICATION', {
        status: '',
        title: `${t('audioTranscriber44', 'file uploading')} ${t('audioTranscriber46', 'success')}`,
        message: '',
      });

      setResultMessage(`${t('audioTranscriber44', 'file uploading')} ${t('audioTranscriber46', 'success')}`);

      setTimeout(() => {
        //@ts-ignore
        dispatch('CLEAR_NOTIFICATION');
      },1000 * 10);

      // showUploadMoadlHandler(false);
      // setIsLoading(false);
      //@ts-ignore
      dispatch('SET_GLOADING', false);

    } catch(err) {
      console.log(err);

      // setSelectedFiles([]);
      // setDroppedFiles([]);

      //// set isUploadFailed to get services-info again
      dispatch('SET_ISUPLOADFAILED', true);

      //@ts-ignore
      dispatch('SHOW_NOTIFICATION', {
        status: 'error',
        title: `${t('audioTranscriber44', 'file uploading')} ${t('audioTranscriber48', 'failed')} ${err.message && err.message}`,
        message: '',
      });

      // setTimeout(() => {
      //   //@ts-ignore
      //   dispatch('CLEAR_NOTIFICATION');
      // },1000 * 10);

      setResultMessage('upload failed');
      
      // setIsLoading(false);
      //@ts-ignore
      dispatch('SET_GLOADING', false);
    }

  };


  const s3fileUploadLf = async (
    url, 
    token, 
    storePath, 
    file, 
    bucketName,
    totalFileNum,
    fileIdx,
    uploadApp,
  ) => {
    try {
      // let priceId;

      // if (usageBasedPrice) {
      //   priceId = usageBasedPrice.id;
      // }
    
      const dataForProcess = {
        bucket: bucketName,
        storePath: storePath,
        filename: file.name,
        totalFileNum: totalFileNum,
        fileIdx: fileIdx,
        // uploadId: localStorage.getItem('userId') + '-' + Date.now(),
        uploadApp: uploadApp,
        processAction: 'storeFiles',
        
        // fileSize: file.size,
      };

      const response = await uploadLargeFileForProcess(
        url,
        `/bucket/object2`,
        token,
        file,
        5*10**6,
        localStorage.getItem('customerId'),
        '',
        dataForProcess,
      );

      if (!response.ok) {
        throw new Error('error occured')
      }

      const resData = await response.json()
      // console.log(response, resData);
      if (resData.data && resData.dataForMetadata) {
        return resData;
      }

    } catch(err) {
      console.log(err);
      // throw err;
    }
  
  };


  let filesUploadActionBody

  filesUploadActionBody = (
    <div >
      {canUpload && (
        <div>
          {uploadNameFile && (
            <div>
              <div>
                {uploadNameFile.name} ({numeral(uploadNameFile.size).format('0.0 b')})
              </div>
              <br/>

              <FilesUploadNameChange 
                uploadNameFile={uploadNameFile}
                setUploadNameFile={setUploadNameFile}
              />

              <div>
                <button className='btnBase'
                  style={{ fontSize: "1.25rem", fontWeight: "bold", border: "1px solid gray" }}
                  disabled={isLoading}
                  onClick={() => { 
                    filesUploadHandler(
                      '', 
                      [uploadNameFile],
                      uploadApp,
                    );
                  }}
                >
                  {t('fileUploadAction04', 'Upload')} {marks.uploadMark}
                </button>
              </div>
            </div>
          )}


        </div>
      )}
      {isLoading && (
        <div>
          <Loader />
        </div>
      )}
      {resultMessage && (
        <div>
          <strong>{resultMessage}</strong>
        </div>
      )}

      {/* {!canUpload && (
        <div>
          <ImagePhotoAuthInfo />
        </div>
      )} */}
    </div>
  )

  return (
    <Fragment>
      <div>{filesUploadActionBody}</div>
      <FilesUploadActionSocket />
    </Fragment>
  )
}

export default FilesUploadAction;
